<template>
  <v-chip
    outline
    :color="fechaHoraPasadoHorario"
  >
    <span class="font-weight-bold">{{ fechaHoraFormateada }}</span>
  </v-chip>
</template>
<script>
import moment from "moment";
import { mapActions } from "vuex";
import typesUtils from "@/store/types/utils";
import typesDominios from "../store/types/Dominios.js";
export default {
  name:"ChipFechaHora",
  data() {
    return {
      vFechaHora: "",
      vFechaHoraServ: "",
      horarioAtencion:''
    };
  },
  mounted() {
    this.ObtenerFechaServidor().then((r) => {
      this.vFechaHoraServ = r.data;
      this.ObtenerTiempoReal();
    });
    this.ObtenerHoraAtencion();

  },
  methods: {
    ...mapActions({
      ObtenerFechaServidor: typesUtils.actions.ObtenerFechaServidor,
      ObtenerHorarioAtencion:typesDominios.actions.ObtenerHorarioAtencion
    }),
    ObtenerTiempoReal() {
      this.AvanzarTiempo();
      let time = this.vFechaHoraServ;
      this.vFechaHora = time;

      setInterval(() => {
        this.AvanzarTiempo();
        time = this.vFechaHoraServ;
        this.vFechaHora = time;
      }, 1000);
    },
    AvanzarTiempo() {
      this.vFechaHoraServ = moment(this.vFechaHoraServ).add(1, "seconds");
    },
    ObtenerHoraAtencion(){
      if(localStorage.getItem('pObjDatosSession')){
      const datosSesion = JSON.parse(localStorage.getItem('pObjDatosSession'))
      this.ObtenerHorarioAtencion(datosSesion.oficinaId).then((r)=>{
        const datos = r.data
       // this.horarioAtencion = Object.groupBy(datos, horario => horario.nombreOficina);
        this.horarioAtencion = r.data
      })
    }
    },
  },
  computed: {
    fechaHoraFormateada() {
      return moment(this.vFechaHora).format('HH:mm:ss');
    },
    fechaHoraPasadoHorario() {
       const horaServer = moment(this.vFechaHora).format('HH:mm');
        const valorCopiado = {...this.horarioAtencion[this.horarioAtencion.length-1]}
        const horaAdministrativa= valorCopiado.horaFin
        if( this.$validacion.hora1MayorAHora2(horaServer, String(horaAdministrativa)))
          return "error"
        else
          return "warning"
    },
  },
}
</script>

